export default __webpack_public_path__ + "static/media/chatting.fb6db36c.mp4";